export default __webpack_public_path__ + "static/media/notifications_8.e0455fa2.png";